import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap'
import * as styles from './_SubmitButton.scss'

const SubmitButton = ({
  buttonText
  , isValid
  , isSubmitting
  , preventDefault
  , onClick
  , size
  , className
  , disabled
}) => (
  <Button type='submit'
    className={`${className || ''} ${styles['submit-button']}`}
    variant={'primary'}
    size={size || 'lg'}
    onClick={(e) => {
      if (preventDefault) {
        e.preventDefault()
      }
      if (onClick) {
        onClick()
      }
    }}
    disabled={disabled !== undefined ? disabled : (!isValid || isSubmitting)}
  >
    <span>{buttonText}</span>
  </Button>)

SubmitButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  isValid: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onClick: PropTypes.func,
  preventDefault: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool
}

export default SubmitButton
